// @flow

import * as React from 'react';
import styled from '@emotion/styled';
import { borderRadius, borderWidth, padding, rgba } from 'polished';

import SimpleSticky from 'app/components/commons/SimpleSticky';

type Props = {
  children?: any,
  first?: boolean,
  justifyContent?: string,
  isTableHeader?: boolean,
  noPadding?: boolean,
  scrollable?: boolean,
  stickyOffset?: number,
  usePanelColor?: boolean
};

const defaultProps = {
  children: undefined,
  first: false,
  justifyContent: 'space-between',
  isTableHeader: false,
  noPadding: false,
  scrollable: false,
  stickyOffset: 0,
  usePanelColor: false
};

const Wrapper = styled.div(
  ({ justifyContent, theme }) => ({
    alignItems: 'center',
    borderStyle: 'solid',
    lineHeight: 1,
    ...borderWidth(0, 0, 1),
    display: 'flex',
    fontSize: theme.fontSize.xxsmall,
    fontWeight: theme.fontWeight.demiBold,
    justifyContent,
    position: 'relative',
    textTransform: 'uppercase'
  }),
  ({ isTableHeader, noPadding, theme }) =>
    !noPadding
      ? { ...padding(theme.spacing.xsmall, isTableHeader ? '0' : theme.spacing.small) }
      : {},
  ({ first, theme }) => (first ? borderRadius('top', theme.borderRadius.default) : {}),
  ({ scrollable, theme }) =>
    scrollable
      ? {
          [theme.mediaQuery.mobileOnly]: {
            overflowY: 'scroll',
            WebkitOverflowScrolling: 'touch'
          }
        }
      : {},
  ({ theme, usePanelColor }) =>
    usePanelColor
      ? {
          backgroundColor: theme.color.panel,
          borderColor: rgba(theme.color.panelAccent, 0.3),
          color: theme.color.panelAccent
        }
      : {
          backgroundColor: theme.color.basis2,
          borderColor: theme.color.basis3,
          color: theme.color.white
        }
);

function RowHeader({
  children,
  first,
  isTableHeader,
  justifyContent,
  noPadding,
  scrollable,
  stickyOffset,
  usePanelColor
}: Props) {
  return (
    <SimpleSticky offsetTop={stickyOffset}>
      <Wrapper
        first={first}
        isTableHeader={isTableHeader}
        justifyContent={justifyContent}
        noPadding={noPadding}
        scrollable={scrollable}
        usePanelColor={usePanelColor}
      >
        {children}
      </Wrapper>
    </SimpleSticky>
  );
}

RowHeader.defaultProps = defaultProps;

export default RowHeader;
